/**
 * @fileoverview > handler for the "/engagement/:app_group_id/test_send" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementAppGroupIdTestSendCacheKeys } from "./constants";
import type { PostEngagementAppGroupIdTestSendProps, EngagementTestSendResult } from "./types";

export const postEngagementTestSend = reactQueryMutationAdapter(
  engagementAppGroupIdTestSendCacheKeys,
  (props: PostEngagementAppGroupIdTestSendProps): Promise<EngagementTestSendResult> => {
    return fetch(
      `/engagement/${props.appGroupId}/test_send`,
      "POST",
      {
        individual_recipient_ids: props.individualRecipientIds,
        internal_user_group_ids: props.internalUserGroupIds,
        message: props.message,
        is_workflow_step: props.isWorkflowStep,
        link_config_set: props.linkConfigSet,
        user_id: props.userId,
        custom_user_hash: props.customUserHash,
        trigger_properties_hash: props.triggerPropertiesHash,
        ...props.platformSpecificParams,
        send_test_as_attachment: props.sendTestAsAttachment,
        component_store: props.componentStoreData,
      },
      {},
      {
        propagateFetchRequestError: false,
      }
    );
  }
);
